import clsx from "clsx";
import React from "react";
import toast, { Toast } from "react-hot-toast";

type CustomToastProps = {
    t: Toast;
    message: string;
    type: "error" | "warning" | "success";
    title?: string;
};

const CustomToast = ({ t, message, type, title }: CustomToastProps) => (
    <div
        className={`bg-white border-[#E2E8F0] border-[1px] px-6 py-3 shadow-[0px_4px_8px_-4px_rgba(16,24,40,0.03),0px_4px_4px_-4px_rgba(16,24,40,0.04)] rounded-[6px] fixed font-rocGroteskMedium max-w-[408px] ${
            t.visible ? "animate-enter" : "animate-leave"
        }`}
        style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 9999999999,
        }}
    >
        <div className="flex justify-between items-center">
            <div className="flex items-center justify-start gap-2">
                {type === "error" ? (
                    <i className="ri-error-warning-fill text-[#CC0000]"></i>
                ) : type === "warning" ? (
                    <span className="material-symbols-outlined text-y-10 text-base">warning</span>
                ) : (
                    <span
                        className={clsx(
                            "material-icons text-tradeally-blue text-base",
                            type === "success" && "!text-[##0AAD0A]"
                        )}
                    >
                        check_circle
                    </span>
                )}
                <p className="text-sm text-g-75 ">
                    {" "}
                    {title
                        ? title
                        : type === "error"
                        ? "Error"
                        : type === "warning"
                        ? "Warning"
                        : "Success"}
                </p>
            </div>

            {t.type !== "loading" && (
                <button onClick={() => toast.dismiss(t.id)}>
                    <i className="ri-close-line text-[#64748B] ml-4"></i>
                </button>
            )}
        </div>

        {message && <div className=" text-sm text-[#64748B]">{message}</div>}
    </div>
);

export default CustomToast;
